<template lang="pug">
  .property(
    v-if="! hidden && (value || options.length)"
    :class="{ selectable, 'is-invalid': options.length && !activeOption && showValidationInfo }"
  )
    .label(v-if="property.label && !hideLabel")
      label {{ property.label }}
    .value(v-if="value" v-html="value")
    .options(v-else-if="options")
      button.button.is-small.is-link.option(
        v-for="option in options"
        :class="{ 'is-active': activeOption && activeOption.id === option.id, 'is-not-available': !option.available, 'is-out-of-stock': !option.sellable }"
        :disabled="!valid || !validArticles || !validArticles.length || !option.sellable"
        @click="select(option)"
      )
        img.swatch(v-if="option.image && option.image.url" :src="option.image.url")
        span {{ option.value }}
      .form-field
        p.help.is-danger(v-if="!activeOption && showValidationInfo") Pflichtfeld
</template>

<script>
import nl2br from 'nl2br';

export default {
  name: 'Property',
  props: {
    property: {
      type: Object,
      required: true
    },
    validArticles: {
      type: Array,
      required: false
    },
    sellableArticles: {
      type: Array,
      required: false
    },
    activeOption: {
      type: Object,
      required: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    manageStock: {
      type: Boolean,
      default: false
    },
    valid: {
      type: Boolean,
      default: false
    },
    showValidationInfo: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    options: []
  }),
  computed: {
    hidden() {
      return !this.property.options.length;
    },
    selectable() {
      return this.property.options.length > 1;
    },
    value() {
      if (this.selectable || this.hidden) return undefined;
      return nl2br(this.property.options[0].value);
    }
    // options() {
    // }
  },
  methods: {
    select(option) {
      this.$emit('select', { property: this.property, option });
    }
  },
  mounted() {
    // TODO
    // if not this.activeOption
    // check of there are multiple options (this.selectable)
    // but only one is available
    // trigger the 'select' event for the only option

    if (this.selectable && !this.hidden) {
      let options = this.property.options;

      options.forEach(option => {
        let sellable = true;
        if (this.property.articleRequired && this.sellableArticles && this.sellableArticles.length) {
          // check if is sellable
          // ---
          // sellable means there is some stock
          // for any article with this property value
          sellable = false;

          const relatedSellableArticles = this.sellableArticles.filter(article => {
            // pay attention to stock
            let match = false;
            article.propertyPivots.forEach(el => {
              const property = el.property;
              const value = el.value;

              if (this.property.id === property.id && value[option.key] === option.value) {
                match = true;
              }
            });
            return match;
          });

          sellable = !!relatedSellableArticles.length;
        }
        option.sellable = sellable;

        let available = true;
        if (this.property.articleRequired && !this.activeOption && this.validArticles && this.validArticles.length) {
          // check if is available
          // ---
          // available means there is some stock
          // for articles with all property values matching the current selection
          // NOTE: keep the cart in mind

          available = false;

          const relatedAvailableArticles = this.validArticles.filter(article => {
            // pay attention to stock
            let match = false;
            article.propertyPivots.forEach(el => {
              const property = el.property;
              const value = el.value;

              if (this.property.id === property.id && value[option.key] === option.value) {
                match = true;
              }
            });
            return match;
          });

          available = !!relatedAvailableArticles.length;
        }
        option.available = available;
      });

      this.options = Object.freeze(options);
    }
  }
};
</script>

<style lang="sass" scoped>
img.swatch
  @apply border-r-1 border-gray-200
  position: relative
  height: 24px
  display: inline-block
  margin-right: 0.5rem
  margin-left: -1px
  // margin-left: calc(-1rem - 1px)
  top: -1px
  @screen md
    height: 30px
.label
  font-weight: 500
  label
    // padding-bottom: .175em // fix text position

.is-invalid
  .label label
    color: theme('colors.red.500')
  button
    box-shadow: 0 0 0 0.1rem theme('colors.red.500')

.value
  min-height: 34px
  padding-left: 2px
  font-weight: 350
  // padding-bottom: .175em // fix text position
  // white-space: pre
  // button
  //   @apply h-8 px-4
  //   padding-bottom: .175em // fix text position
  //   margin: 2px
  //   pointer-events: none
button
  margin: 2px
.is-not-available
  opacity: .5
.form-field
  margin-bottom: 0
.help
  text-transform: initial
</style>
